export const A_SET_PROFILE = 'A_SET_PROFILE';
export const A_CLEAR_PROFILE = 'A_CLEAR_PROFILE';
export const A_LOG_IN_WITH_AUTH0 = 'A_LOG_IN_WITH_AUTH0';
export const A_SET_USER_STATUS = 'A_SET_USER_STATUS';
export const A_SET_AUTH_TOKEN = 'A_SET_AUTH_TOKEN';
export const A_SET_API_KEY = 'A_SET_API_KEY';
export const A_INIT_GATEKEEPER = 'A_INIT_GATEKEEPER';
export const A_INIT_GATEKEEPER_CALLBACK = 'A_INIT_GATEKEEPER_CALLBACK';
export const A_SET_GATEKEEPER_STATUS = 'A_SET_GATEKEEPER_STATUS';
export const A_SET_SESSION = 'A_SET_SESSION';
export const A_LOG_OUT_WITH_AUTH0 = 'A_LOG_OUT_WITH_AUTH0';
export const A_START_GATEKEEPER = 'A_START_GATEKEEPER';
export const A_START_GATEKEEPER_CALLBACK = 'A_START_GATEKEEPER_CALLBACK';
export const A_LISTENING_TO_SESSION = 'A_LISTENING_TO_SESSION';
export const A_SET_ACCESS_TOKEN = 'A_SET_ACCESS_TOKEN';
export const A_SET_EPHEMERAL_KEY = 'A_SET_EPHEMERAL_KEY';
export const A_SET_ID_TOKEN = 'A_SET_ID_TOKEN';
export const A_RELOAD_EPHEMERAL_KEY = 'A_RELOAD_EPHEMERAL_KEY';
export const A_CLEAR_EPHEMERAL_KEY = 'A_CLEAR_EPHEMERAL_KEY';
export const A_SET_TOKEN_STATUS = 'A_SET_TOKEN_STATUS';
export const A_SET_GRANTS = 'A_SET_GRANTS';
export const A_SET_USER_PAGES = 'A_SET_USER_PAGES';
export const A_CHECK_EXPIRATION = 'A_CHECK_EXPIRATION';
